export default __webpack_public_path__ + "static/media/image1.016cd486.png";